import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'absolute',
  pure: true,
})
export class AbsolutePipe implements PipeTransform {

  transform(
    value: number | null | undefined,
  ): number | null | undefined {

    if (value === null || value === undefined) {
      return value;
    }

    return Math.abs(value);
  }

}
